import React from 'react';
import { FormattedDTE } from '@upstart/harmony/lib/legos/dtEntitiesTypes';
import { AddOnsDteTypeahead } from './AddOnsDteTypeahead';
import Input from '../../PencilEditor/Input';
import { AddOn } from './AddOnsModal';

export function getDmsInput({
  isDMSFlowEnabled,
  isDealerTrackEnabled,
  addOn,
  index,
  dtEntities,
  dteMap,
  onDteChange,
  onDMSCodeChange,
  disabled,
}: {
  isDMSFlowEnabled: boolean;
  isDealerTrackEnabled: boolean;
  addOn: AddOn;
  index: number;
  dtEntities: FormattedDTE[];
  dteMap: Map<string, FormattedDTE>;
  onDteChange: (index: number, selected: FormattedDTE) => void;
  onDMSCodeChange: (i: number) => (event: any) => void;
  disabled: boolean;
}) {
  if (isDMSFlowEnabled) {
    if (isDealerTrackEnabled) {
      return (
        <AddOnsDteTypeahead
          dtEntities={dtEntities}
          dteMap={dteMap}
          addOn={addOn}
          index={index}
          onChange={onDteChange}
          disabled={disabled}
        />
      );
    }

    return (
      <Input
        key={index}
        onChange={onDMSCodeChange(index)}
        value={addOn.dmsCode}
        disabled={disabled}
      />
    );
  }

  return null;
}
